"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPermalink = void 0;
const getPermalink = (text) => text
    .toLowerCase()
    .replace(/[^a-z0-9]/gi, "-")
    .replace(/\-\-+/g, "-");
exports.getPermalink = getPermalink;
